import { Flex, Stepper } from '@servicetitan/anvil2';
import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import { WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';
import { ConsentDataStore, ESignContainer } from '@servicetitan/financing-decision-shared';
import { ComponentType } from 'react';

export const EsignStep: ComponentType<any> = ESignContainer;

export const EsignButtons = () => {
    const { consentData } = ConsentDataStore.useStore();
    const { applicationData } = ApplicationDataStore.useStore();
    const { CancelApplicationButton } = WorkflowButtonsStore.useStore();

    let awaitingEsignConsent = consentData.applicantConsent === undefined;

    if (applicationData?.coApplicant?.hasCoApplicant) {
        awaitingEsignConsent = awaitingEsignConsent || consentData.coApplicantConsent === undefined;
    }

    return (
        <Flex justifyContent="space-between">
            <Stepper.PrevButton label="Back" />
            <Flex gap="3" justifyContent="flex-end" grow={1}>
                <CancelApplicationButton>Cancel</CancelApplicationButton>
                <Stepper.NextButton disabled={awaitingEsignConsent} nextLabel="Next" />
            </Flex>
        </Flex>
    );
};
